import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReviewApi from "../../apis/review.api";
import AppAlert from "../../components/AppAlert";
import OutlineBlueBtn2 from "../../components/buttons/OutlineBlueBtn2";
import OutlineSubBtn from "../../components/buttons/OutlineSubBtn";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import SolidDisabledBtn from "../../components/buttons/SolidDisabledBtn";
import AppUtils from "../../utils";
import CountableTextAreaForReviewBox from "../../components/CountableTextAreaForReviewBox";
import PopupArea from "../../components/modal/PopupArea";
import { REVIEW_STATUS_CODE,LOCAL_STORAGE_KEYS } from "../../constants/AppConstants";
import { ROUTE_PATHS } from "../../constants/Router";
import {
  EDIT,
  EXCLUDE,
  POST,
  POST_AGAIN,
  POST_COMMENT_FAIL,
  THIS_IS_EXCLUDED_REVIEW,
  TIME_IS_EXPIRED,
  WRITE_COMMENT_BTN,
} from "../../text-data";
import { getReviewStatus, isCheckExpired } from "./ReviewBox";
import {
  ReviewPopupEditFail,
  ReviewPopupEditSuccess,
  ReviewPopupNotInputButPost,
  ReviewPopupPostMoreThan1000Chars,
  ReviewPopupQuestion,
  ReviewPopupWriteComment,
} from "./ReviewPopup";
import useAuth from "../../hooks/useAuth";

function ReviewBoxBtns(props) {
  const {
    comment_reg_status_code,
    reviewId,
    reviewResponse,
    isUseAIComment,
    reviewItem,
    reg_dttm,
    isEdit,
    isNotUsePostDay,
    isWriteComment,
    refreshReview,   
    textAreaHeight,
    comment_reg_result_msg
  } = props;

  const [openEmpty, setOpenEmpty] = useState(false);
  const [open1000, setOpen1000] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openPostConfirm, setOpenPostConfirm] = useState(false);
  const [openPostSuccess, setOpenPostSuccess] = useState(false);
  const [openDeleteAll, setOpenDeleteAll] = useState(false);
  const [openEditSuccess, setOpenEditSuccess] = useState(false);
  const [openFail, setOpenFail] = useState(false);
  const [openExclude, setOpenExclude] = useState(false);
  const textAreaRef = useRef(null);
  const textAreaValueRef = useRef("");

  const [textAreaValue, setTextAreaValue] = useState(
    isWriteComment ? "" : textAreaValueRef.current || reviewResponse || ""
  );
  const [loading, setLoading] = useState(false);

  const reviewStatus = getReviewStatus(comment_reg_status_code);

  const [popupContent, setPopupContent] = useState(null);

  const closeModal = () => {
    setPopupContent(null);
  };

  const navigate = useNavigate();

  const evhPostComment = function () {
    setOpenPostConfirm(true);
  };

  const evhWriteComment = function () {
    evhEdit(true);
  };
  const { ceoInfo } = useAuth();
  const evhEdit = function (isWrite = false) {
    let isShowPopup = true;
    let period = localStorage.getItem(`${LOCAL_STORAGE_KEYS.PERIODNOTSHOWREVIEWPOPUP}-${ceoInfo.ceo_idx}`);
    period = period ? +period : 0;
    isShowPopup = new Date().getTime() > period;
    if (isShowPopup) {
      setPopupContent(
        <ReviewPopupWriteComment
          closeModal={closeModal}
          onOk={() => {
            closeModal();
          }}
        />
      );
    }
    navigate(ROUTE_PATHS.EditReview, {
      state: {
        reviewItem: JSON.parse(JSON.stringify(reviewItem)),
        isWrite: isWriteComment
      }
    });
  };

  const onExclude = async () => {
    if (!loading) {
      try {
        setLoading(true);
        const res = await ReviewApi.exclude(reviewItem?.review_idx);
        if (res.data.data) {
          await refreshReview();
        }
      } finally {
        setLoading(false);
      }
      setOpenExclude(false);
    }
  };

  const EditBtnFull = function () {
    return (
      <OutlineBlueBtn2 className="w-full py-3" onClick={evhEdit}>
        {EDIT}
      </OutlineBlueBtn2>
    );
  };

  const EditBtnSmall = function () {
    return <OutlineSubBtn onClick={evhEdit}>{EDIT}</OutlineSubBtn>;
  };

  const onCreateComment = () => {
    const textAreaValue = textAreaRef.current.value;
    setTextAreaValue(textAreaValue);
    if (textAreaValue.length === 0) {
      setOpenEmpty(true);
    } else if (textAreaValue.length > 1000) {
      setOpen1000(true);
    } else {
      setOpenConfirm(true);
    }
  };

  const PostBtn = function () {
    return (
      <OutlineBlueBtn2 className="py-3" onClick={evhPostComment}>
        {POST}
      </OutlineBlueBtn2>
    );
  };

  const PostAgainBtn = function () {
    return (
      <OutlineBlueBtn2 className="py-3" onClick={evhPostComment}>
        {POST_AGAIN}
      </OutlineBlueBtn2>
    );
  };

  const WriteCommentBtn = () => {
    return (
      <OutlineBlueBtn2 className="py-3 mt-6" onClick={evhWriteComment}>
        {WRITE_COMMENT_BTN}
      </OutlineBlueBtn2>
    );
  };

  const ExcludeBtn = () => {
    return (
      <div
        className="text-sm text-666 text-center mt-3"
        style={{ padding: "13px 0" }}
        onClick={() => setOpenExclude(true)}
      >
        {EXCLUDE}
      </div>
    );
  };

  const EditPostExclude = () => {
    if (!isNotUsePostDay &&(reviewStatus === REVIEW_STATUS_CODE.PENDING.code || reviewStatus === REVIEW_STATUS_CODE.UNANSWERED.code ) && ceoInfo.ceo_type ==='PREMIUM') {
      return (
        <>
          <div className="popup-btns mt-6">
            <EditBtnFull />
          </div>
          <ExcludeBtn reviewId={reviewId} />
        </>
      );
    } else {
      return (
        <>
          <div className="popup-btns mt-6 flex">
            <EditBtnSmall />
            <PostBtn />
          </div>
          <ExcludeBtn reviewId={reviewId} />
        </>
      );
    }
  };
  const onConfirm = async () => {
    if (reviewItem) {
      const submitData = {
        review_idx: reviewItem?.review_idx,
        content: textAreaRef.current.value,
      };
      try {
        setLoading(true);
        if(ceoInfo.ceo_type ==='PREMIUM'){
          await ReviewApi.edit(submitData);
        }
        else if(ceoInfo.ceo_type ==='NORMAL'){
          await ReviewApi.editForNormalUser(submitData);
        }
        setOpenEditSuccess(true);
      } catch (error) {
        setOpenFail(true);
      } finally {
        setLoading(false);
      }

      setOpenConfirm(false);
    }
  };

  const onPostComment = async () => {
    if (!loading) {
      try {
        setLoading(true);
       const res =  await ReviewApi.write(reviewItem?.review_idx);
       if(res.data?.data.success){
        setOpenPostSuccess(true);
       }
       else {
        setPopupContent(
          <ReviewPopupEditFail  closeModal={closeModal} desc={AppUtils.getCommentFailMessage(res.data?.data.error_msg)}  />
        );
       }
      } catch (error) {
        setPopupContent(
          <ReviewPopupEditFail  closeModal={closeModal} desc={'사장님 사이트에 수정 전의 댓글이 <br />이미 등록 되었어요.'}/>
        );
      } finally {
        setLoading(false);
      }
      setOpenPostConfirm(false);
    }
  };

  const WritingArea = function () {
    useEffect(function () {
      if (textAreaRef.current) {
        // textAreaRef.current.focus();
        // const textAreaLength = textAreaRef.current.value.length;
        // textAreaRef.current.focus();
        // textAreaRef.current.setSelectionRange(textAreaLength, textAreaLength);
        textAreaRef.current.scrollTop = 10000000;
      }
    }, []);
    const onSubmit = function () {
      if (!textAreaValue) {
        setPopupContent(<ReviewPopupNotInputButPost closeModal={closeModal} />);
        return;
      }
      if (textAreaValue.length > 1000) {
        setPopupContent(
          <ReviewPopupPostMoreThan1000Chars closeModal={closeModal} />
        );
        return;
      }

      setPopupContent(
        <ReviewPopupQuestion
          closeModal={closeModal}
          onOk={() => {
            new Promise((resolve) => setTimeout(resolve, 500)).then(() => {
              if (Math.random() > 0.5) {
                setPopupContent(
                  <ReviewPopupEditSuccess closeModal={closeModal} />
                );
              } else {
                setPopupContent(
                  <ReviewPopupEditFail closeModal={closeModal} />
                );
              }
            });
          }}
        />
      );
    };
    const SubmitBtns = () => {
      const label =
        reviewStatus === REVIEW_STATUS_CODE.UNANSWERED.code ? "POST" : "SAVE";
      if (reviewStatus === REVIEW_STATUS_CODE.UNANSWERED.code) {
        if (textAreaValue && textAreaValue.length <= 1000) {
          return (
            <SolidBlueBtn className="w-full mt-6" onClick={onSubmit}>
              {label}
            </SolidBlueBtn>
          );
        }
        return (
          <SolidDisabledBtn className="w-full mt-6" onClick={onSubmit}>
            {label}
          </SolidDisabledBtn>
        );
      }
    };

    const onClear = () => {
      setTextAreaValue(textAreaRef.current?.value);
      setOpenDeleteAll(true);
    };

    return (
      <CountableTextAreaForReviewBox          
          isWriteComment={isWriteComment}
          textAreaRef={textAreaRef}
          textAreaHeight={textAreaHeight}
          defaultValue={textAreaValue}
          onChange={(v) => {
            // setTextAreaValue(v);
            textAreaValueRef.current = v;            
          }}
          onClear={onClear}
          loading={loading}
          onCreateComment={onCreateComment}
        />
    );
  };
  const Btns = function () {
    if (isEdit) {
      return <WritingArea />;
    }
    if (reviewStatus === REVIEW_STATUS_CODE.UNANSWERED.code) {
      if (isUseAIComment) {
        return <EditPostExclude />;
      }
      else if (!isUseAIComment && ceoInfo.ceo_type === 'NORMAL') {
        return <WriteCommentBtn />;
      }

    }

    if (reviewStatus === REVIEW_STATUS_CODE.PENDING.code) {
      return <EditPostExclude />;
    }

    if (reviewStatus === REVIEW_STATUS_CODE.FAILED.code) {
      const Tmp = () => {
        return (
          <>
            {isCheckExpired(reg_dttm) ? null : (
              <>
                <div className="popup-btns mt-6">
                  <EditBtnSmall />
                  <PostAgainBtn />
                </div>
                <ExcludeBtn reviewId={reviewId} />
              </>
            )}
          </>
        );
      };
      return (
        <div>
          <p className="text-center text-15 pt-8 pb-4">{POST_COMMENT_FAIL}</p>
          <p style={{color:'#F25467'}} className="text-center text-12 pt-8">{AppUtils.getCommentFailMessage(comment_reg_result_msg)}</p>
          <Tmp />
        </div>
      );
    }

    if (reviewStatus === REVIEW_STATUS_CODE.EXPIRED.code) {
      return <div className="text-center py-4">{TIME_IS_EXPIRED}</div>;
    }

    if (reviewStatus === REVIEW_STATUS_CODE.EXCLUDED.code) {
      return <div className="text-center py-4">{THIS_IS_EXCLUDED_REVIEW}</div>;
    }
    return <div></div>;
  };

  return (
    <>
      <Btns />
      <PopupArea popupContent={popupContent} closeModal={closeModal} />

      {/* Empty */}
      <AppAlert
        title="등록하실 내용을 입력해 주세요."
        desc="댓글 내용이 입력되어야 등록이 가능해요."
        open={openEmpty}
        onOk={() => setOpenEmpty(false)}
        okText="확인"
        type="error"
      />

      {/* 1000 characters */}
      <AppAlert
        title="1,000자 이내로 입력해 주세요."
        desc="댓글은 공백 포함 최대 1,000자 까지만 <br />
        입력하실 수 있어요."
        open={open1000}
        onOk={() => setOpen1000(false)}
        okText="확인"
        type="error"
      />

      {/* Confirm */}
      <AppAlert
        title="이 댓글로 등록하시겠어요?"
        desc="현재 작성된 댓글을 사장님 사이트에 <br />
        전송합니다. 계속하시겠어요?"
        open={openConfirm}
        onOk={onConfirm}
        onClose={() => setOpenConfirm(false)}
        okText="계속"
        cancelText="취소"
        type="question"
        loading={loading}
      />

      {/* Post success */}
      <AppAlert
        title="댓글 등록이 요청되었어요!"
        desc="등록 완료까지 최대 한 시간이 소요돼요."
        open={openPostSuccess}
        onOk={async () => {
          setOpenPostSuccess(false);
          refreshReview();
        }}
        okText="확인"
        type="success"
      />

      {/* Delete all */}
      <AppAlert
        title="입력된 내용을 지우시겠어요?"
        desc="지금까지 작성하신 내용이 전부 지워져요."
        open={openDeleteAll}
        onOk={() => {
          setTextAreaValue("");
          setOpenDeleteAll(false);
        }}
        onClose={() => {
          setOpenDeleteAll(false)
        }}
        okText="지우기"
        cancelText="취소"
        type="error"
        okButtonRed={true}
      />

      {/* Edit comment done */}
      <AppAlert
        title="댓글 수정이 완료되었어요!"
        desc="수정된 댓글로 등록 요청하실 수 있어요."
        open={openEditSuccess}
        onOk={() => {
          setOpenEditSuccess(false);
          if (window.appBridge) {
            try {
              window.appBridge.setEnableScroll && window.appBridge.setEnableScroll(true);
            } catch (e) { }
          }
          navigate(-1);
        }}
        okText="확인"
        type="success"
      />

      {/* Edit comment done */}
      <AppAlert
        title="댓글 수정에 실패했어요."
        desc="사장님 사이트에 수정 전의 댓글이 <br />
        이미 등록 되었어요."
        open={openFail}
        onOk={() => setOpenFail(false)}
        okText="확인"
        type="error"
      />

      {/* Confirm */}
      <AppAlert
        title="이 댓글로 등록하시겠어요?"
        desc="현재 작성된 댓글을 사장님 사이트에 <br />
        전송합니다. 계속하시겠어요?"
        open={openPostConfirm}
        onOk={onPostComment}
        onClose={() => setOpenPostConfirm(false)}
        okText="계속"
        cancelText="취소"
        type="question"
        loading={loading}
      />

      {/* Exclude */}
      <AppAlert
        title="추천 댓글이 삭제되고 <br/>
        아무런 댓글도 등록되지 않아요."
        desc="댓글 등록 제외 시 해당 댓글은 더 이상 <br/>
        스폰지에서 관리 하실 수 없어요."
        open={openExclude}
        onOk={onExclude}
        onClose={async () => {
          setOpenExclude(false);
          await refreshReview();
        }}
        cancelText="취소"
        okText="등록 제외"
        type="error"
        okButtonRed={true}
        loading={loading}
      />
    </>
  );
}

export default ReviewBoxBtns;
